import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { AuthService } from '../../../../services/auth/auth.service';
import { ToolsService } from '../../../../services/tools/tools.service';
import { AuthPageManageService } from '../../../../services/manage/page-manage/auth-page-manage.service';
import { LangagesService } from '../../../../services/manage/langages/langages.service';
import { MatDialog, MatDialogConfig, MatDialogState } from '@angular/material/dialog';
import { CheckAddressComponent } from 'src/app/components/dialogs/check-address/check-address.component';
import { MediaObserver } from '@angular/flex-layout';
import { SalemethodService } from 'src/app/services/api/salemethod/salemethod.service';
import * as _ from "lodash";
import { PanierService } from 'src/app/services/manage/panier/panier.service';
import { BlobOptions } from 'buffer';
import { UserTouchTerminalComponent } from 'src/app/components/dialogs/user-touch-terminal/user-touch-terminal.component';
import { PointofsaleService } from 'src/app/services/api/pointofsale/pointofsale.service';
import { borneOrderService } from 'src/app/services/borneOrder/borneOrder.service';
import { ActivatedRoute } from '@angular/router';
import { CssService } from "../../../../services/css-service";

@Component({
  selector: 'app-header-order',
  templateUrl: './header-order.component.html',
  styleUrls: ['./header-order.component.css']
})

export class HeaderOrderComponent implements OnInit {

  @Output() eventConnection = new EventEmitter();

  @Output() closeSaleMethodDialEvent = new EventEmitter();
  @Output() devicechangeEvent = new EventEmitter();
  @Output() menuOpened: any

  @Input() redirectPage: string | any;
  @Input() openedSaleMethodDial: boolean | any;

  currUser$: any;
  currSm$: any;
  currPos: any = this.tools.getStor("point_of_sale");
  basket$: any = [];

  languages: Object[] = [
    {
      url: "assets/img/countryflag/english.png",
      value: "en"
    },
    {
      url: "assets/img/countryflag/french.png",
      value: "fr"
    }
  ];
  obserCurrSm: any;
  AccesBornePayment: boolean = false;
  dialogBorne: any;
  hideRegisterIncrisptionModeBorne: boolean = false;
  hidebackModeBorne = false;
  shopVisible = true;
  constructor(
    private authService: AuthService,
    private smApi: SalemethodService,
    private langServ: LangagesService,
    public tools: ToolsService,
    public cssService: CssService,
    public authPageServ: AuthPageManageService,
    private dialog: MatDialog,
    public media: MediaObserver,
    private panierMan: PanierService,
    private posApi: PointofsaleService,
    private borneOrderService: borneOrderService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.AccesBornePayment = false;
    this.shopVisible = true
    this.authService.getUser.subscribe(user => {
      user ? this.currUser$ = user : this.currUser$ = false;
    });
    this.panierMan.getPanier.subscribe(basket => {
      this.basket$ = basket;
    })
    this.obserCurrSm = this.smApi.getSaleMeth().subscribe(sm => {
      this.currSm$ = sm;
      this.hideRegisterIncrisptionModeBorne = false;
      this.hidebackModeBorne = false;

      if (!sm && this.tools.checkCurrentPage("endorder")) {
        this.currSm$ = this.tools.getStor(SalemethodService.TAG_STORAGE);
      }

      if (this.currSm$ && this.currSm$.enable_online_payment && this.currSm$.disable_authentification > 0 && this.currPos && (this.tools.checkCurrentPage("endorder") || this.tools.checkCurrentPage("product"))) {
        this.AccesBornePayment = true;
        this.borneActive();
      }
      if (!sm && !this.currSm$) {
        if (this.tools.checkCurrentPage("s")) {
          this.borneActive();
          if (this.hideRegisterIncrisptionModeBorne)
            this.hidebackModeBorne = true;
        }
      }
      if (this.currSm$ && !this.currSm$.webshop_visible && this.tools.checkCurrentPage("product"))
        this.shopVisible = false;
    });
  }

  borneActive() {
    if (this.tools.getStor("devicePaybridge")) {
      this.hideRegisterIncrisptionModeBorne = true;
      if (this.currUser$)
        this.signOut();
    }
  }

  ngOnDestroy(): void {
    if (this.obserCurrSm)
      this.obserCurrSm.unsubscribe();
  }

  /**
* @description dialog user control
*@param info
*
*/
  borneDevicetoConnect(): void {
    if (this.dialogBorne && this.dialogBorne.getState() === MatDialogState.OPEN)
      return;
    const myConf = new MatDialogConfig();
    myConf.data = {
      borne: true
    };

    this.media.isActive("xs")
      ? (myConf.width = "100%", myConf.height = "100%", myConf.panelClass = "dialog-borne")
      : (myConf.width = "80%", myConf.height = "80%", myConf.panelClass = "dialog-borne");
    this.dialogBorne = this.dialog.open(UserTouchTerminalComponent, myConf);
    this.dialogBorne.afterClosed().subscribe((result: any) => {
      if (result) {
        this.devicechangeEvent.emit(result);
        //timeout pour afficher la popup continuer la commande
        result == 'currdevice' ? this.borneOrderService.continueOrder() : this.borneOrderService.removeContinueOrderTimeout();
        this.hideRegisterIncrisptionModeBorne = result == 'currdevice' ? true : false;
        // this.hidebackModeBorne=this.hideRegisterIncrisptionModeBorne &&!this.tools.checkCurrentPage("endorder")?true:false;
        if (this.hideRegisterIncrisptionModeBorne)
          this.signOut();
      }
      this.tools.setOnPopState(true);
    });
  }

  goProduct(): void {
    this.tools.goProductPage(null, this.currSm$);
  }

  goBack(): void {
    if (this.tools.checkCurrentPage("endorder"))
      this.goProduct();
    else if (this.tools.checkCurrentPage("Product")) {
      if (!this.currPos.onlyOnePOS) {
        if (this.openedSaleMethodDial)
          this.closeSaleMethodDialEvent.emit();
        const endurl = this.tools.getStor("url_encode") ? this.tools.getStor("url_encode") : null;
        const id_merchant = this.tools.getStor("id_merchant") ? this.tools.getStor("id_merchant") : null;

        //recupere le compte si plus rien dans le localstorage
        if (!endurl && !id_merchant)
          this.getAccount();
        else {
          /****
           mode borne
            **/
          // go back page product
          this.borneActive();
          if (this.hideRegisterIncrisptionModeBorne) {
            this.route.params.subscribe((params: any) => {
              if (params && params.smId)
                this.tools.goProductPage();
              else {
                setTimeout(() => {
                  window.location.reload();
                }, 100);
              }
            })
          } else {
            /****
            mode normal
             **/

            let currSm: any = this.tools.getStor(SalemethodService.TAG_STORAGE);
            //page product
            if (currSm) {
              this.smApi.getSaleMethods().subscribe((saleMeths) => {
                if (saleMeths && saleMeths.length > 1) {
                  this.route.params.subscribe((params: any) => {
                    if (params && params.smId)
                      this.tools.goProductPage();
                    else {
                      setTimeout(() => {
                        window.location.reload();
                      }, 100);
                    }
                  })
                }
                else // si une seule salemethod on redirige vers  le choix de  point of sale
                  this.tools.goPointOfSalePage();
              })
            }
            else //on passe de page salemethod a la  point of sale
              this.tools.goPointOfSalePage();
          }
        }
      }
    }
  }
  getAccount() {
    this.posApi.getUserAccount().then(data => {
      if (data && data.object) {
        this.tools.setStor("url_encode", data.object.url_encode);
        this.tools.setStor("id_merchant", data.object.id_webshop);
        this.tools.goPointOfSalePage();
      }
    })
  }

  goHome(): void {
    window.open(window.location.origin, '_blank');
  }

  goRegister(): void {

    if (this.openedSaleMethodDial) {
      this.closeSaleMethodDialEvent.emit();
    }
    this.authPageServ.goRegister(this.redirectPage)
  }

  goLogin($ev?: any): void {


    if (this.openedSaleMethodDial) {
      this.closeSaleMethodDialEvent.emit();
    }


    this.authPageServ.goLogin(this.redirectPage)
  }


  chooseLanguage(lang: string): void {
    this.langServ.setLang(lang);
  }

  openCheckAddress(): void {

    const myConf = new MatDialogConfig();
    this.media.isActive("xs") ? myConf.width = "100%" : myConf.minWidth = "400px";
    myConf.autoFocus = true;
    myConf.data = {};
    myConf.data.fromSmDial = false;
    const myDial = this.dialog.open(CheckAddressComponent, myConf);
    myDial.afterClosed().subscribe(result => { });
  }

  logOut(): void {

    this.authService.logOut(null, "header-order");
    this.eventConnection.emit();
  }
  signOut(): void {

    this.authService.signOut();

  }

}
